import { render } from "./QuestionRegistration.vue?vue&type=template&id=6b5c986a&scoped=true"
import script from "./QuestionRegistration.vue?vue&type=script&lang=js"
export * from "./QuestionRegistration.vue?vue&type=script&lang=js"

import "./QuestionRegistration.vue?vue&type=style&index=0&id=6b5c986a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5c986a"]])

export default __exports__